import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api } from "../../ConsumeApiController";

export async function getDashboardCrm() {
    // 1. EL ESCUDO: Definimos un esqueleto vacío pero seguro.
    // Si algo sale mal, devolvemos esto para que la UI no explote.
    const fallbackData = {
        kpis: { total_unique: '0', avg_ticket: '$0.00', retention_rate: '0%' },
        segmentation: { recurrent_pct: 0, new_pct: 0, risk_pct: 0 },
        top_consumers: [],
        live_pulse: []
    };

    try {
        const response = await api.get(CompanyRoutes.CRM.DASHBOARD_DATA);
        console.log(response)

        // 2. NAVEGACIÓN SEGURA: Validamos que la respuesta contenga data real.
        // OJO: Como en el backend enviamos { success: true, data: { ... } }, 
        // la data real suele estar en response.data.data dependiendo de tu configuración de Axios.
        const payload = response?.data?.data || response?.data;

        if (!payload) {
            console.warn("CRM Dashboard: El servidor respondió, pero sin el payload de datos esperado.");
            return fallbackData;
        }

        // 3. DESESTRUCTURACIÓN CON SALVAVIDAS: 
        // Si el backend olvida enviar una de las 4 llaves, le asignamos la del fallback.
        const {
            kpis = fallbackData.kpis,
            segmentation = fallbackData.segmentation,
            top_consumers = fallbackData.top_consumers,
            live_pulse = fallbackData.live_pulse
        } = payload;

        return { kpis, segmentation, top_consumers, live_pulse };

    } catch (error) {
        // 4. ATERRIZAJE DE EMERGENCIA: Capturamos el error silenciosamente.
        console.error(
            "CRM Dashboard Error ->", 
            error?.response?.data?.message || error.message || "Error desconocido de red"
        );
        
        // Retornamos el esqueleto vacío. Tu UI mostrará todo en cero o vacío, pero no colapsará.
        return fallbackData;
    }
}



/**
 * Obtiene la lista paginada y filtrada de clientes del CRM.
 * @param {Object} params - { page, search, segment, sort_by, sort_dir, merchant_id }
 */
export async function getClientDirectoryCrm(params = {}) {
    // Esqueleto seguro en caso de que falle la API
    const fallbackData = {
        data: [],
        pagination: {
            total: 0,
            per_page: 15,
            current_page: 1,
            last_page: 1
        }
    };

    try {
        const response = await api.get(CompanyRoutes.CRM.DIRECTORY, { params });

        if (!response || !response.success) {
            console.warn("CRM Directory: El servidor respondió con un estatus de fallo.");
            return fallbackData;
        }

        return {
            data: response.data.customers || fallbackData.data,
            pagination: response.pagination || fallbackData.pagination
        };

    } catch (error) {
        console.error(
            "CRM Directory Error ->", 
            error?.response?.message || error.message || "Error de conexión"
        );
        return fallbackData;
    }
}

export async function getClientDetailCrm(customerId){
    const response = await api.get(CompanyRoutes.CRM.CUSTOMER_DETAIL(customerId));
    return response;
}